import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { MessageTypes } from 'src/models/constants';
import { MediaCenterService } from '../media-center.service';

@Component({
  selector: 'app-media-center-video',
  templateUrl: './media-center-video.component.html',
  styleUrls: ['./media-center-video.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MediaCenterVideoComponent {
  @Input() url: string;
  @Input() localMedia: string;
  @Input() localThumbnail: string;
  @Input() progress: number;
  @Input() mediaStatus: string;
  @Input() fileSize: number;
  @Input() height: number;
  @Input() width: number;

  mediaType = MessageTypes.VIDEO;
  localCoverStatus = true;

  constructor(private _mediaCenterService: MediaCenterService) {}

  get media() {
    return this._mediaCenterService.getMedia(this.localMedia);
  }

  get showCover() {
    return this._mediaCenterService.getCover(this.mediaStatus);
  }

  hideCover() {
    this.localCoverStatus = false;
  }
}
